export default "__VITE_ASSET__b79552ae__"